import { Injectable } from '@angular/core';
import { GenericServicesMotoristaService } from './generic-services-motorista.service';
import { HttpClient } from '@angular/common/http';
import { MensagensService } from 'max-ng-lib';

@Injectable({ providedIn: 'root' })
export class AjudanteService extends GenericServicesMotoristaService {

  constructor(
    private _mensagensService: MensagensService,
    private _httpClient: HttpClient,
  ) { super(); }

  getMensagensService(): MensagensService {
    return this._mensagensService;
  }

  getHttpClient(): HttpClient {
    return this._httpClient;
  }

  getUrlRecurso(): string {
    return '/ajudante';
  }
}
